import { render, staticRenderFns } from "./InvalidCompanyName.vue?vue&type=template&id=9804e22c"
import script from "./InvalidCompanyName.vue?vue&type=script&lang=js"
export * from "./InvalidCompanyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports